import React, { ReactElement } from 'react';
import dynamic from 'next/dynamic';
import classNames from 'classnames/bind';
import RootLayout from 'layouts/RootLayout';
import styles from 'pages/digital-tools/DigitalTools.module.scss';

const cn = classNames.bind(styles);

const SectionHeader = dynamic(() => import('sections/DigitalTools/components/SectionHeader'));
const SectionCards = dynamic(() => import('sections/DigitalTools/components/SectionCards'));
const SectionInfo = dynamic(() => import('sections/DigitalTools/components/SectionInfo'));

export default function DigitalTools() {
  return (
    <div className={cn('digital-tools')}>
      <SectionHeader/>
      <SectionCards/>
      <SectionInfo/>
    </div>
  );
}

export const getStaticProps = async () => {
  return {
    props: {
      title: 'Digital Tools for Freight Forwarding | DF Alliance',
      description: 'Explore the range of digital tools offered by DF Alliance to streamline logistics, from real-time tracking to advanced ERP solutions, making global shipping easier.',
      path: '/digital-tools',
    },
  };
};

DigitalTools.getLayout = function getLayout(page: ReactElement) {
  return <RootLayout>{page}</RootLayout>;
};
